<template>
    <div class="error-401">
        <icon type="weiguanlian" width="200" height="200"></icon>
        <p>{{ $t('i18n.401') }}</p>
        <p>
            <a :href="ITPortalURL">{{ $t('i18n.back') }}</a>
        </p>
    </div>
</template>

<script>
// 导入全局变量
export default {
    computed: {
        ITPortalURL() {
            return `${process.env.VUE_APP_IT_PORTAL_URL}#/?lang=${this.$store.state.language}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.error-401 {
    position: relative;
    text-align: center;
    top: 50%;
    transform: translateY(-50%);

    a {
        font-size: 12px;
    }
}
</style>
